import React from 'react'
import { useNotFound, NotFoundProps } from './useNotFound'

const NotFound: React.FC<NotFoundProps> = (props: NotFoundProps) => {
  const { message } = useNotFound(props)

  return (
    <div className='container py-5'>
      <section>
        <div className='row'>
          <div className='col-12 text-center fs-4 fw-bold'>{message}</div>
        </div>
      </section>
    </div>
  )
}

export default NotFound
